import React from 'react';
import { FieldError, UseFormRegister } from 'react-hook-form';

type InputFieldProps = {
    name: string;
    label?: string;
    type?: string;
    register: UseFormRegister<any>;
    error?: FieldError;
    required?: boolean;
    placeholder?: string;
};

const InputField: React.FC<InputFieldProps> = ({ name, label, type = 'text', register, error, required = false, placeholder = '' }) => {
    return (
        <div className="space-y-1">
            {label && (
                <label htmlFor={name} className="block font-medium">
                    {label} {required && <span className="text-red-500">*</span>}
                </label>
            )}
            <input
                id={name}
                type={type}
                placeholder={placeholder}
                {...register(name)}
                className={`w-full border px-3 py-2 rounded ${error ? 'border-red-500' : 'border-gray-300'
                    }`}
            />
            {error && <p className="text-sm text-red-500">{error.message}</p>}
        </div>
    );
};

export default InputField;
